import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Skuska} from '../model/skuska';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {TerminDetailComponent} from '../termin-detail/termin-detail.component';
import {SkuskyList} from '../model/SkuskyList';
import {TranslateService} from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {MatChipListboxChange} from '@angular/material/chips';

@Component({
    selector: 'app-skusky',
    templateUrl: './skusky.component.html',
    styleUrls: ['./skusky.component.css'],
    standalone: false
})
export class SkuskyComponent implements OnInit, OnDestroy
{
    skusky: SkuskyList = new SkuskyList();
    skuskySubscription = new Subscription();
    search = '';
    predmety: string[];
    private smallSearch: string;
    showSmallFilter = false;

    kdeSomPrihlaseny = true;
    kdeSaMozemPrihlasit = true;

    @ViewChild('searchInput') searchInput: ElementRef;

    pocetVyhovujucich = 0;

    constructor(
        private appService: AppService,
        private dialogService: MatDialog,
        private translation: TranslateService,
        private http: HttpClient
    ) {
    }

    ngOnInit(): void
    {
        this.skuskySubscription = this.appService.skuskySubject
            .subscribe((data: Skuska[]) => {
                this.processData(data);
        });

        const skusky = this.appService.getSkusky();

        this.processData(skusky);

        this.kdeSomPrihlaseny = this.appService.getKdeSomPrihlaseny();
        this.kdeSaMozemPrihlasit = this.appService.getKdeSaMozemPrihlasit();

        this.switchSkusky();
  }

  ngOnDestroy(): void {
    this.skuskySubscription.unsubscribe();
  }

    openTerminDetail($event: MouseEvent, termin: Skuska)
    {
        $event.stopPropagation();

        this.dialogService.open(
            TerminDetailComponent, {
                data: {
                    termin
                }
            });
    }

    private getPredmety(skusky: Skuska[]): string[]
    {
        const skratky = skusky.map<string>(s => s.predmetSkratka);
        return skratky.filter((i, ix) => skratky.indexOf(i) === ix);
    }

    private processData(data: Skuska[])
    {
        this.skusky = new SkuskyList();

        data.forEach((s: Skuska) => {
            this.skusky.add(s);
        });

        this.predmety = this.getPredmety(data);

        this.zistiPocetVyhovujucich();
    }

  prihlasit(skuska: Skuska)
  {
    this.appService.prihlasit(skuska);
  }

    odhlasit(skuska: Skuska) {
        this.appService.odhlasit(skuska);
    }

  switchSmallFilter(): void {
    this.showSmallFilter = !this.showSmallFilter;
    if (this.showSmallFilter) {
      this.search = this.smallSearch;
      setTimeout(() => this.searchInput.nativeElement.focus(), 0);
    } else {
      this.smallSearch = this.search;
      this.search = '';
    }
  }

  switchSkusky()
  {
      this.appService.setKdeSomPrihlaseny(this.kdeSomPrihlaseny);
      this.appService.setKdeSaMozemPrihlasit(this.kdeSaMozemPrihlasit);

      this.zistiPocetVyhovujucich();
  }

    private zistiPocetVyhovujucich(): void
    {
        this.pocetVyhovujucich  = -1;

        this.skusky.skusky.forEach((skuskyByDate) => {
            skuskyByDate.skusky.forEach((s) => {
                const vyhovuje =
                    (this.kdeSomPrihlaseny && s.datumPrihlasenia !== null) ||
                    (this.kdeSaMozemPrihlasit && s.bude && !s.terminNaplneny) ||
                    (!this.kdeSaMozemPrihlasit && !this.kdeSomPrihlaseny);

                if (vyhovuje) {
                    this.pocetVyhovujucich = 1;
                    return;
                }
            });
        });
    }

  filterChange($event: MatChipListboxChange)
  {
      this.kdeSomPrihlaseny = false;
      this.kdeSaMozemPrihlasit = false;

      if ($event.value.includes('2')) {
          this.kdeSomPrihlaseny = true;
      }

      if ($event.value.includes('1')) {
          this.kdeSaMozemPrihlasit = true;
      }

      this.switchSkusky();
  }

    getPopis(kodHodnotenia: string) {
        return this.appService.getPopisHodnotenia(kodHodnotenia);
    }

    protected mozeSaPrihlasit(skuska: Skuska)
    {
        if (skuska.terminNaplneny) {
            return false;
        }

        if (!skuska.hodnotenieTermin && skuska.hodnoteniePredmet && !skuska.mozeSaPrihlasit) {
            return false;
        }

        return skuska.bude;
    }
}
